// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TqY1","rightAdornment":"Header_rightAdornment__3IK2q"};